import React from 'react';
import { Flex, Link } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';

export const RequisitionDetailsList = ({ data = [], p = '16px' }) => {
  if (!data || data.length === 0) return null;

  return (
    <Flex
      flexDir="column"
      gap="8px"
      p={p}
      bg="white"
      width="100%"
      overflow="hidden"
    >
      {data.map(({ label, value, href }, index) => {
        const isReactElement = React.isValidElement(value);

        const valueContent = isReactElement ? (
          value
        ) : href ? (
          <Link href={href} target="_blank" minWidth="0" flex="1">
            <KText
              size="sm-medium"
              _hover={{ textDecoration: 'underline' }}
              isTruncated
              enableTooltip={true}
              tooltipText={value || ' '}
            >
              {value || ' '}
            </KText>
          </Link>
        ) : (
          <KText
            size="sm-medium"
            flex="1"
            minW="0"
            isTruncated
            enableTooltip
            tooltipText={value || '-'}
          >
            {value || '-'}
          </KText>
        );

        return (
          <Flex key={index} flexDir="row" gap="8px" minW="0" overflow="hidden">
            <KText size="sm-semi-bold" minW="fit-content" flexShrink={0}>
              {label}:
            </KText>
            {valueContent}
          </Flex>
        );
      })}
    </Flex>
  );
};
